<template>
  <div class="frisbuy-pause-button" @click="$emit('click')">
    <template v-if="isPause">
      <div class="frisbuy-pause-button__play">
        <span class="frisbuy-pause-button__play--button"></span>
        <span class="frisbuy-pause-button__play--shadow"></span>
      </div>
    </template>
    <template v-else>
      <div class="frisbuy-pause-button__pause">
        <span></span>
        <span></span>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
$svgWidth: 12px;
$svgHeight: 17px;
$shadowColor: rgba(34, 60, 80, 0.5);

.frisbuy-pause-button {
  display: flex;
  position: relative;

  width: $svgWidth;
  height: $svgHeight;

  cursor: pointer;

  &__play {
    width: fit-content;
    height: fit-content;

    &--button,
    &--shadow {
      display: block;
      position: absolute;

      width: $svgWidth;
      height: $svgHeight;

      color: transparent;
      background-color: transparent;
    }

    &--button {
      top: 0;
      left: 0;

      border-top: calc($svgWidth / (3 / 2)) solid transparent;
      border-left: calc($svgWidth * (3 / 2.5)) solid #fff;
      border-bottom: calc($svgWidth / (3 / 2)) solid transparent;
    }

    &--shadow {
      top: -2px !important;
      left: -1px !important;

      border-style: solid;
      border-top: calc(3px + ($svgWidth / (3 / 2))) solid transparent;
      border-left: calc(3px + ($svgWidth * (3 / 2.5))) solid $shadowColor;
      border-bottom: calc(3px + ($svgWidth / (3 / 2))) solid transparent;

      z-index: -1;
    }
  }

  &__pause {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    width: fit-content;
    height: fit-content;

    gap: 2px;

    span {
      display: block;
      width: calc($svgWidth / 2);
      height: $svgHeight;

      background-color: #fff;
      border: 1px solid $shadowColor;
    }
  }
}
</style>

<script>
export default {
  emits: ["click"],

  props: {
    isPause: {
      type: Boolean,
      require: false,
      default: false,
    },
  },

  data() {
    return {};
  },
};
</script>
